import { ArchiveEditIcon } from './ArchiveEditIcon';

/**
 * author: Colton Wiscombe
 * id 6FC882E2-B34D-47ED-8E18-6CD197A0D709
 * name archive-edit
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-edit.svg
 * tags
 * - Edit / Modify 
 */
export const BoxEditIcon = ArchiveEditIcon;
export default BoxEditIcon